class StickyFilterButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.placeholder = this.querySelector('.collection-toolbar__filter-placeholder');
    this.topOffset = parseInt(this.dataset.topOffset || 100, 10);
    this.ticking = false;

    this.init();
  }

  init() {
    if (!this.button) return;

    // Add click event listener to button
    this.button.addEventListener('click', (event) => {
      const ariaControls = this.button.getAttribute('aria-controls');
      if (ariaControls) {
        const drawer = document.getElementById(ariaControls);
        if (drawer) {
          // Try different approaches to open the drawer
          if (typeof drawer.openDrawer === 'function') {
            drawer.openDrawer();
          } else {
            // Find the dialog element inside the filter-drawer
            const dialog = drawer.querySelector('dialog[ref="drawer"]');
            if (dialog && typeof dialog.showModal === 'function') {
              console.log('Opening dialog directly via showModal');
              dialog.showModal();
            } else {
              console.log('Dialog not found or showModal not available', dialog);
              // Fallback: try to trigger via custom event
              const openEvent = new CustomEvent('drawer:open', { bubbles: true });
              drawer.dispatchEvent(openEvent);
            }
          }
        } else {
          console.log('Drawer not found with ID:', ariaControls);
        }
      }
    });

    // Check if mobile
    this.isMobile = () => window.innerWidth <= 989;

    if (this.isMobile()) {
      // On mobile, always fixed at bottom, no scroll behavior needed
      return;
    }

    // Calculate dimensions for placeholder on desktop only
    const rect = this.button.getBoundingClientRect();
    this.placeholder.style.width = `${rect.width}px`;
    this.placeholder.style.height = `${rect.height}px`;

    window.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
    window.addEventListener('resize', this.onResize.bind(this), { passive: true });
  }

  onScroll() {
    // Skip scroll behavior on mobile
    if (this.isMobile()) return;

    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.checkPosition();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  onResize() {
    // Reset on resize in case we switch between mobile/desktop
    if (this.isMobile()) {
      // Clean up desktop sticky state if switching to mobile
      if (this.classList.contains('is-sticky-active')) {
        this.classList.remove('is-sticky-active');
        this.button.classList.remove('is-sticky');
        this.button.style.top = '';
        this.button.style.left = '';
        this.button.style.width = '';
      }
      return;
    }

    // Update placeholder size on desktop
    if (!this.classList.contains('is-sticky-active')) {
      const rect = this.button.getBoundingClientRect();
      this.placeholder.style.width = `${rect.width}px`;
      this.placeholder.style.height = `${rect.height}px`;
    } else {
      // If sticky, update left position
      const rect = this.getBoundingClientRect();
      this.button.style.left = `${rect.left}px`;
    }
    this.checkPosition();
  }

  checkPosition() {
    // Skip position check on mobile
    if (this.isMobile()) return;

    const containerRect = this.getBoundingClientRect();
    const shouldBeSticky = containerRect.top <= this.topOffset;

    if (shouldBeSticky) {
      if (!this.className.includes('is-sticky-active')) {
        this.classList.add('is-sticky-active');
        this.button.classList.add('is-sticky');
        this.button.style.top = `${this.topOffset}px`;
        this.button.style.left = `${containerRect.left}px`;

        // Copy width to ensure it doesn't shrink/grow
        this.button.style.width = `${containerRect.width}px`;
      } else {
        // Update left in case of horizontal scroll/resize while sticky
        this.button.style.left = `${containerRect.left}px`;
      }
    } else {
      if (this.className.includes('is-sticky-active')) {
        this.classList.remove('is-sticky-active');
        this.button.classList.remove('is-sticky');
        this.button.style.top = '';
        this.button.style.left = '';
        this.button.style.width = '';
      }
    }
  }
}

if (!customElements.get('sticky-filter-button')) {
  customElements.define('sticky-filter-button', StickyFilterButton);
}
